<script>
    import { onMount } from 'svelte';
    import { fetchAllAreaCourseTypeCourses } from '/public/services/courses.js';   
    import CoursePayload from './CoursePayload.svelte';
    import { navigateTo } from 'svelte-router-spa';

    export let area_id;
    export let course_type_id;

    let area = null;
    let course_type = null;
    let loading = true;
    let courses = null;
    
    function loadCourses() {
        fetchAllAreaCourseTypeCourses(area_id, course_type_id).then(res => {
            if (res.success) {
                area = res.data.area;
                course_type = res.data.course_type;
                courses = res.data.courses;

                loading = false;
            } else {
                navigateTo('/home');
            }
        });
    }    

    onMount(() => {
        loadCourses();
    });
</script>
{#if loading === true}

    <div class='text-center'>
        <h4>
            <span class='ajax-ball-loader'></span> Looking for Courses....
        </h4>
    </div>

{:else}

    <div class='clearfix'>
        
        {#if area.logo != null}

            <img src={area.logo} class='col-md-1 img-responsive float-start me-3' alt='Area'/>

        {/if}

        <span class='float-end ms-3'>
            Found <span class='badge bg-primary shadow-sm rounded'>{ courses.all.count }</span> Courses
        </span>
        <h2>
            { area.name } First Aid Courses
        </h2>
        <div>
            <span class='fas fa-map-marker'></span> { area.address }
        </div>
        
        {#if area.phone }

            <div>
                <span class='fas fa-mobile'></span> { area.phone }
            </div>

        {/if}
    </div>    

    <hr/>

    <div class='card mb-3'>
        <div class='card-header'>
            { course_type.name }
        </div>
        <div class='card-body'>
            <div class='text-end'>
                <h4>
                    ${ course_type.price }
                </h4>
            </div>

            {@html course_type.description}

        </div>
    </div>

    <hr/>

    <CoursePayload
        courses={courses}
    />

{/if}